<app-header />
<main class="app-content">
  <router-outlet />
</main>
<app-footer />
<app-report-widget />